import BApp from "../../../modules/BApp";
import BConfig from "../../../Modules/BConfig";
import BRequest from "../../../Modules/BRequest";
import BRestQuantity from "../../Modules/BRestQuantity";
import Showcase from "./Showcase";

export default class Edible
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.diary-day-search-edibles-edible`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = `${this.selector()}__add-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();

				const item = new this(event.target.closest(`${this.selector()}`));
				item.addToDiary();
			}
		});
	}

	static getEdibleTemplate(edible)
	{
		const title = edible.title;
		const imageUrl = edible?.images[0]?.EDIBLE_SEARCHABLE?.url;
		const url = edible?.url;
		const reference = edible.reference;
		const edibleNutrientQuantities = edible.edibleNutrientQuantities;

		const edibleQuantity = edibleNutrientQuantities ? new BRestQuantity(edibleNutrientQuantities.edibleQuantity).getQuantity() : null;
		const energyQuantity = edibleNutrientQuantities ? new BRestQuantity(edibleNutrientQuantities.nutrientQuantities.ENERGY).getQuantity() : null;
		const carbsQuantity = edibleNutrientQuantities ? new BRestQuantity(edibleNutrientQuantities.nutrientQuantities.CARBS).getQuantity() : null;
		const fatsQuantity = edibleNutrientQuantities ? new BRestQuantity(edibleNutrientQuantities.nutrientQuantities.FATS).getQuantity() : null;
		const proteinsQuantity = edibleNutrientQuantities ? new BRestQuantity(edible.edibleNutrientQuantities.nutrientQuantities.PROTEINS).getQuantity() : null;
		const itemClass = `diary-day-search-edibles-edible`;

		return `<li class="${itemClass}" data-reference="${reference}">
			<p class="${itemClass}__image"${imageUrl ? `` : ` hidden`}>
				${url ? `<a href="${url}" target="_blank">` : ``}${imageUrl ? `<img src="${imageUrl}" alt="${title}" />` : ``}${url ? `</a>` : ``}
			</p>
			<div class="${itemClass}__main">
				<h4 class="${itemClass}__title">
					${url ? `<a href="${url}" target="_blank">` : ``}${title}${url ? `</a>` : ``}
				</h4>
				<ul class="${itemClass}__nutrients">
					${energyQuantity && edibleQuantity ? `<li class="${itemClass}__nutrient">
						<p class="${itemClass}__nutrient-value">
							${energyQuantity.getReadable()}
							<span class="${itemClass}__nutrient-value-hint">
								na ${edibleQuantity.getReadable()}
							</span>
						</p>
					</li>` : ``}
					${carbsQuantity ? `<li class="${itemClass}__nutrient">
						<h5 class="${itemClass}__nutrient-title">
							Sacharidy
						</h5>
						<p class="${itemClass}__nutrient-value">
							${carbsQuantity.getReadable()}
						</p>
					</li>` : ``}
					${fatsQuantity ? `<li class="${itemClass}__nutrient">
						<h5 class="${itemClass}__nutrient-title">
							Tuky
						</h5>
						<p class="${itemClass}__nutrient-value">
							${fatsQuantity.getReadable()}
						</p>
					</li>` : ``}
					${proteinsQuantity ? `<li class="${itemClass}__nutrient">
						<h5 class="${itemClass}__nutrient-title">
							Bílkoviny
						</h5>
						<p class="${itemClass}__nutrient-value">
							${proteinsQuantity.getReadable()}
						</p>
					</li>` : ``}
				</ul>
			</div>
			<p class="${itemClass}__button">
				<button type="button" class="b-button b-button--compact ${itemClass}__add-button">
					<span class="material-icons b-icon b-icon--left">
						add_circle
					</span>
					Přidat
				</button>
			</p>
		</li>`;
	}

	getSelector()
	{
		return Edible.selector();
	}

	getShowcase()
	{
		return new Showcase(this.el.closest(Showcase.selector()));
	}

	getTitle()
	{
		return this.el.querySelector(`${this.getSelector()}__title`).textContent.trim();
	}

	getReference()
	{
		return this.el.dataset.reference;
	}

	addToDiary()
	{
		// TODO - temporary solution before diary rewrite
		const sectionElement = this.el.closest(`.profile-diary-day-group`).querySelector(`.profile-diary-day-section[data-section="meals"]`);
		const sidebarElement = document.querySelector(`.diary-day-sidebar`);
		const mealsNutrientsContainerElement = document.querySelector(`.profile-diary-day-meals-nutrients-container`);
		const entriesElement = sectionElement.querySelector(`.profile-entries--diary-day-meals`);
		const templateHTML = sectionElement.querySelector(`.preloader-template`).innerHTML;
		const preloaderElement = BApp.createElement(templateHTML);
		preloaderElement.querySelector(`.template-title`).innerHTML = this.getTitle();
		entriesElement.append(preloaderElement);

		this.getShowcase().getForm().reset();
		this.getShowcase().getForm().getDialogElement().close();

		BRequest.post(BConfig.getRoute("api.v2.diary.meals.createFromEdible"), {
			timeConsumed: this.getShowcase().getForm().getDiaryDayElement().dataset.date,
			edible: {
				reference: this.getReference(),
			},
			servings: 1,
		}).then(response => {
			entriesElement.innerHTML = response.data.templates.entries;
			sidebarElement.innerHTML = response.data.templates.sidebar;
			mealsNutrientsContainerElement.innerHTML = response.data.templates.mealsNutrients;
		});
	}
}
